import React from 'react'

import ProjectSession from "../../../../../model2/project/project-session"
import TeamIcon from "../../../../../gd-components/icons/team/team"

type Props = {
    projectId   : ID
    teamId      : ID
}

// const debug = "ProjectTeamIcon"
const debug = false

export default function ProjectTeamIcon(props: Props) {
    const sessionProject: ProjectSession = gd.session.projects.get(props.projectId)!

    debug && console.log(debug, 'render', sessionProject)

    const projectClasses = Classes("project-big s1 gd-c-{0}".f(sessionProject.color), sessionProject.iconClass)
    const teamClasses = Classes("project-big s1 gd-c-{0} m-l--10 white".f(sessionProject.color))

    return (
        <div className="details-project-user-icon">
            <div className={projectClasses}/>
            <TeamIcon className = {teamClasses}
                      size      = {28}
                      teamId    = {props.teamId}/>
        </div>
    )
}
